import React from 'react'
import { Button, Collapse, Form } from 'react-bootstrap'
import * as Logger from 'loglevel'
import HubApi from '../../util/HubApi'

export class ResetPasswordForm extends React.Component {
  constructor(props) {
    super(props)
    this.form = React.createRef()
    this.state = {
      password1: '',
      password2: '',
      formError: null,
      isStatusEnabled: false,
      spaceWarningShow: false
    }
    this.submitHandler = this.submitHandler.bind(this)
  }

  onChange = (event, isPassword) => {
    if (isPassword && event.target.value.includes(' ')) {
      this.setState({ spaceWarningShow: true })
    } else {
      this.setState({
        [event.target.name]: event.target.value,
        spaceWarningShow: false
      })
    }
  }

  submitHandler(event) {
    Logger.debug('new password from submitHander, event=', event)
    event.preventDefault()
    if (!event.target.className.includes(' was-validated')) {
      event.target.className += ' was-validated'
    }

    if (this.validateForm()) {
      this.updatePassword()
    }
  }

  updatePassword = async () => {
    const { payload: user } = this.props
    var response = await HubApi.resetUserPassword(user, this.state.password1)
    if (response.ok) {
      Logger.debug(`user password reset.`)
      this.props.onFormSubmitted()
    } else {
      Logger.error(`user password reset failed, response=.`, response)
      const error = await response.json()
      this.setState({
        ...this.state,
        formError: `Failed: ${error.message}`,
        isStatusEnabled: true
      })
    }
  }

  validateForm = () => this.form.current.checkValidity()
  /*
                                 validate
                                error="password must be at least 6 characters."
                                success="right"
                                required
                                pattern=".{6,}"
                                title="password must be at least 6 characters."
    */
  render() {
    // let btnFormStatus = this.state.formError ? (<button className="btn btn-warning small_btn" onClick={this.toggleStatus}><MDBIcon icon="info-circle" /></button>) : null;
    const btnFormStatus = null
    return (
      <div>
        <small className='form-text text-muted'>
          The password must be at least 6 characters in length. It will take
          effect the next time the user logs in.
        </small>

        <Form
          ref={this.form}
          className='needs-validation'
          onSubmit={this.submitHandler}
          noValidate
        >
          <Form.Group>
            <Form.Control
              value={this.state.password1}
              name='password1'
              onChange={(e) => this.onChange(e, true)}
              type='password'
              id='newpwdFormPassword1'
              placeholder='New password'
              pattern='.{6,}'
              required
            />
            <div className='invalid-feedback'>
              Please enter a password that is at least 6 chatacters long.
            </div>
            {this.state.spaceWarningShow ? (
              <div className='warningMsg'>
                Spaces cannot be used for password!
              </div>
            ) : (
              <div />
            )}
          </Form.Group>
          <Form.Group>
            <Form.Control
              value={this.state.password2}
              name='password2'
              onChange={this.onChange}
              type='password'
              id='newpwdFormPassword2'
              placeholder='Confirm new password'
              pattern={this.state.password1}
              required
            />
            <div className='invalid-feedback'>Passwords do not match!</div>
          </Form.Group>
          <Button
            color='light'
            type='submit'
            size='sm'
            className='float-right mr-0'
          >
            Save
          </Button>
        </Form>

        <div className='clearfix'>
          {btnFormStatus}
          <Collapse in={this.state.isStatusEnabled}>
            <small className='form-text text-muted red-text'>
              {this.state.formError}
            </small>
          </Collapse>
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
        <div>
          This form is so ridiculously long that it requires an overflow test
        </div>
      </div>
    )
  }
}
